import { render, staticRenderFns } from "./push-ali.vue?vue&type=template&id=3b61de7e&scoped=true&"
import script from "./push-ali.vue?vue&type=script&lang=js&"
export * from "./push-ali.vue?vue&type=script&lang=js&"
import style0 from "./push-ali.vue?vue&type=style&index=0&id=3b61de7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b61de7e",
  null
  
)

export default component.exports